import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  articleData?: {
    publishedTime?: string;
    modifiedTime?: string;
    author?: string;
    tags?: string[];
  };
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl = 'https://anxindaohang.com',
  ogType = 'website',
  ogImage,
  articleData,
}: SEOHeadProps) {
  useEffect(() => {
    const originalTitle = document.title;
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);
    setMeta('og:title', title, true);
    setMeta('og:description', description, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', canonicalUrl, true);
    setMeta('og:locale', 'zh-CN', true);
    setMeta('og:site_name', '安心导航', true);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);

    if (ogImage) {
      setMeta('og:image', ogImage, true);
      setMeta('twitter:image', ogImage);
    }

    let canonicalEl = document.querySelector('link[rel="canonical"]');
    if (!canonicalEl) {
      canonicalEl = document.createElement('link');
      canonicalEl.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalEl);
    }
    canonicalEl.setAttribute('href', canonicalUrl);

    if (articleData?.publishedTime) {
      setMeta('article:published_time', articleData.publishedTime);
    }
    if (articleData?.modifiedTime) {
      setMeta('article:modified_time', articleData.modifiedTime);
    }
    if (articleData?.author) {
      setMeta('article:author', articleData.author);
    }
    if (articleData?.tags) {
      articleData.tags.forEach((tag) => {
        let tagEl = document.querySelector(`meta[property="article:tag"][content="${tag}"]`);
        if (!tagEl) {
          tagEl = document.createElement('meta');
          tagEl.setAttribute('property', 'article:tag');
          tagEl.setAttribute('content', tag);
          document.head.appendChild(tagEl);
        }
      });
    }

    return () => {
      document.title = originalTitle;
    };
  }, [title, description, keywords, canonicalUrl, ogType, ogImage, articleData]);

  return null;
}